export default __webpack_public_path__ + "static/media/sidebar.9fafce43.png";